export const LOG_IN_USER = 'app/auth/LOG_IN_USER';
export const LOG_OUT = 'app/auth/LOG_OUT';
export const RESET_REDUCER = 'app/auth/RESET_REDUCER';

export const LOG_IN_GUEST = 'app/auth/LOG_IN_GUEST';

export const EDIT_USER_REQUEST = 'app/auth/EDIT_USER_REQUEST';
export const EDIT_USER_SUCCESS = 'app/auth/EDIT_USER_SUCCESS';
export const EDIT_USER_ERROR = 'app/auth/EDIT_USER_ERROR';

export const CHANGE_PASSWORD_REQUEST = 'app/auth/CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'app/auth/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'app/auth/CHANGE_PASSWORD_ERROR';

export const CHANGE_EMAIL_REQUEST = 'app/auth/CHANGE_EMAIL_REQUEST';
export const CHANGE_EMAIL_SUCCESS = 'app/auth/CHANGE_EMAIL_SUCCESS';
export const CHANGE_EMAIL_ERROR = 'app/auth/CHANGE_EMAIL_ERROR';

export const ADD_AVATAR_REQUEST = 'app/auth/ADD_AVATAR_REQUEST';
export const ADD_AVATAR_SUCCESS = 'app/auth/ADD_AVATAR_SUCCESS';
export const ADD_AVATAR_ERROR = 'app/auth/ADD_AVATAR_ERROR';

export const DELETE_AVATAR_REQUEST = 'app/auth/DELETE_AVATAR_REQUEST';
export const DELETE_AVATAR_SUCCESS = 'app/auth/DELETE_AVATAR_SUCCESS';
export const DELETE_AVATAR_ERROR = 'app/auth/DELETE_AVATAR_ERROR';

export const CHANGE_PHONE_NUMBER_REQUEST =
  'app/auth/CHANGE_PHONE_NUMBER_REQUEST';
export const CHANGE_PHONE_NUMBER_SUCCESS =
  'app/auth/CHANGE_PHONE_NUMBER_SUCCESS';
export const CHANGE_PHONE_NUMBER_ERROR = 'app/auth/CHANGE_PHONE_NUMBER_ERROR';

export const EDIT_PHONE_NUMBER_PREVIEW_REQUEST =
  'app/auth/EDIT_PHONE_NUMBER_REQUEST';
export const EDIT_PHONE_NUMBER_PREVIEW_SUCCESS =
  'app/auth/EDIT_PHONE_NUMBER_SUCCESS';
export const EDIT_PHONE_NUMBER_PREVIEW_ERROR =
  'app/auth/EDIT_PHONE_NUMBER_ERROR';

export const CONFIRM_PHONE_NUMBER_REQUEST =
  'app/auth/CONFIRM_PHONE_NUMBER_REQUEST';
export const CONFIRM_PHONE_NUMBER_SUCCESS =
  'app/auth/CONFIRM_PHONE_NUMBER_SUCCESS';
export const CONFIRM_PHONE_NUMBER_ERROR = 'app/auth/CONFIRM_PHONE_NUMBER_ERROR';

export const SEND_SMS_TOKEN_REQUEST = 'app/auth/SEND_SMS_TOKEN_REQUEST';
export const SEND_SMS_TOKEN_SUCCESS = 'app/auth/SEND_SMS_TOKEN_SUCCESS';
export const SEND_SMS_TOKEN_ERROR = 'app/auth/SEND_SMS_TOKEN_ERROR';

export const CHANGE_ERROR_STATUS = 'app/auth/CHANGE_ERROR_STATUS';

export const RESET_PHONE_NUMBER_PREVIEW = 'app/auth/RESET_PHONE_NUMBER_PREVIEW';

export const LOGIN_REQUEST = 'app/auth/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'app/auth/LOGIN_SUCCESS';
export const LOGIN_ERROR = 'app/auth/LOGIN_ERROR';
export const ACCOUNT_CONFIRMATION_SUCCESS =
  'app/auth/ACCOUNT_CONFIRMATION_SUCCESS';
export const ACCOUNT_CONFIRMATION_ERROR = 'app/auth/ACCOUNT_CONFIRMATION_ERROR';

export const VERIFICATION_CODE_NEEDED = 'app/auth/VERIFICATION_CODE_NEEDED';
export const VERIFICATION_CODE_REQUEST = 'app/auth/VERIFICATION_CODE_REQUEST';
export const VERIFICATION_CODE_SUCCESS = 'app/auth/VERIFICATION_CODE_SUCCESS';
export const VERIFICATION_CODE_ERROR = 'app/auth/VERIFICATION_CODE_ERROR';
export const VERIFICATION_CODE_COOKIE = 'verification_code';

export const FETCH_SELF_DETAILS_REQUEST = 'app/auth/FETCH_SELF_DETAILS_REQUEST';
export const FETCH_SELF_DETAILS_SUCCESS = 'app/auth/FETCH_SELF_DETAILS_SUCCESS';

export const UPDATE_USERS_TIMEZONE = 'app/auth/UPDATE_USERS_TIMEZONE';

export const TERMS_NOT_ACCEPTED = 'app/auth/TERMS_NOT_ACCEPTED';

export const TERMS_ACCEPT_REQUEST = 'app/auth/TERMS_ACCEPT_REQUEST';
export const TERMS_ACCEPT_SUCCESS = 'app/auth/TERMS_ACCEPT_SUCCESS';
export const TERMS_ACCEPT_ERROR = 'app/auth/TERMS_ACCEPT_ERROR';

export const VERIFY_SHORT_LINK_REQUEST = 'app/auth/VERIFY_SHORT_LINK_REQUEST';
export const VERIFY_SHORT_LINK_SUCCESS = 'app/auth/VERIFY_SHORT_LINK_SUCCESS';
export const VERIFY_SHORT_LINK_ERROR = 'app/auth/VERIFY_SHORT_LINK_ERROR';

export const VERIFY_USER_KEY_REQUEST = 'app/auth/VERIFY_USER_KEY_REQUEST';
export const VERIFY_USER_KEY_SUCCESS = 'app/auth/VERIFY_USER_KEY_SUCCESS';
export const VERIFY_USER_KEY_ERROR = 'app/auth/VERIFY_USER_KEY_ERROR';

export const VERIFY_SMS_LINK_REQUEST = 'app/auth/VERIFY_SMS_LINK_REQUEST';
export const VERIFY_SMS_LINK_SUCCESS = 'app/auth/VERIFY_SMS_LINK_SUCCESS';
export const VERIFY_SMS_LINK_ERROR = 'app/auth/VERIFY_SMS_LINK_ERROR';

export const CLEAR_ERRORS = 'app/auth/CLEAR_ERRORS';
